module.exports = {
  Exponential: require('./lib/exponential'),
  Polynomial: require('./lib/polynomial'),
  Fibonacci: require('./lib/fibonacci'),
  Linear: require('./lib/strategy'),
  Defined: require('./lib/defined')
}